<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
    setup(){
        
        const store = useStore();
        const data = computed(() => store.getters.professor_data);
        
        return { data };
    }
}
</script>

<template>
    <div class="h2">Introduction</div>
    <div class="main row">
        <div class="picture col-md-2">
            <img src="../assets/img/jrchang.jpg" alt="張介仁" class="w-75">
        </div>
        <div class="data">
            <div class="item" v-for="item in data" :key="item.label">
                <div class="label">
                    <h5> {{ item.label }} </h5>
                </div>
                <div class="data">
                    <h5> {{ item.value}} </h5>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
    .h2{
        width: 10%;
        border-radius:10px;
        background-color:gray;
        text-align:center;
        margin: 10px 10px 10px 10px;
        font-weight:bold;
        color: #fff;
    }
    .main{
        display:flex;
        width:100%;
        padding: 1%;
        >.picture{
            width: 20%;
        }
        >.data{
            width: 80%;
            >.item{
                display:flex;
                >.label{
                    width: 30%;
                }
                >.data{
                    width: 70%;
                }
            }
        }
    }

</style>>
